package org.matthewo.styles

import web.cssom.GridLine

fun span(count: Int): GridLine = "span $count".unsafeCast<GridLine>()
